import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./RentersrightInfo.scss";
import RentersRightBill from '../../forms/renters-right-bill';

const RentersRightBillForm = () => {
  return (
    <React.Fragment>
      <section className="rentersright-info" id="rentersright-form">
        <Container>
          <Row>
            <Col>              
                <div className="renters-box book">
                  
                  <RentersRightBill />
                </div>
                
              <div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default RentersRightBillForm;
